import { render, staticRenderFns } from "./TalonClaimsTable.vue?vue&type=template&id=236ea1f1&scoped=true"
import script from "./TalonClaimsTable.vue?vue&type=script&lang=ts"
export * from "./TalonClaimsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236ea1f1",
  null
  
)

export default component.exports